import React from 'react'
const MatxLogo = ({ src="/assets/images/logos/logo.png" }) => {
    return (
        <img
            alt="Logo"
            src={src}
            style={{
                width: '90px',
                height: '90px',
            }}
        />
    )
}

export default MatxLogo
